import { NotAuthorizedError } from '@adornis/baseql/errors/NotAuthorizedError.js';
import { context } from '@adornis/baseql/server/context.js';
import { hasPlatformUserManage } from './nexus-permission-gate.js';

type RequestContext = { userID?: string; serverContext?: boolean };

/** User list/detail/assignment: platform user-manage or the signed-in user's own record. */
export async function canReadPlatformUser(targetUserId: string): Promise<boolean> {
  const ctx = context as RequestContext;
  if (ctx.serverContext) return true;
  if (await hasPlatformUserManage()) return true;
  return ctx.userID === targetUserId;
}

export async function assertCanReadPlatformUser(targetUserId: string): Promise<void> {
  if (!(await canReadPlatformUser(targetUserId))) {
    throw new NotAuthorizedError('UserManage', 'read user');
  }
}
